import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SharedCommonModule } from 'app/back-office/shared/common.module';
import { LoaderModule } from 'app/shared/components/loader/loader.module';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { DirectivesModule } from '../../directives/directives.module';
import { AgencyService } from '../../services/back-office/agency.service';
import { PaginationModule } from '../pagination/pagination.module';
import { SidebarModule } from '../../../../shared/components/sidebar/sidebar.module';
import { CheckRangePipe } from './shared/pipe/check-range.pipe';
import { SearchBarComponent } from './search-bar.component';
import { SearchService } from 'app/back-office/layout/components/navbar/navbar-search/search.service';
import { AgencyFilterComponent } from './shared/components/agency-filter/agency-filter.component';
import { AmountFilterComponent } from './shared/components/amount-filter/amount-filter.component';
import { AssortmentFilterComponent } from './shared/components/assortment-filter/assortment-filter.component';
import { BasicCollectionFilterComponent } from './shared/components/basic-collection-filter/basic-collection-filter.component';
import { ChannelFilterComponent } from './shared/components/channel-filter/channel-filter.component';
import { CityFilterComponent } from './shared/components/city-filter/city-filter.component';
import { CheckBoxPaginedComponent } from './shared/components/common/check-box-pagined/check-box-pagined.component';
import { InputFilterComponent } from './shared/components/common/input-filter/input-filter.component';
import { NumberFilterComponent } from './shared/components/common/number-filter/number-filter.component';
import { RadioPaginatedComponent } from './shared/components/common/radio-paginated/radio-paginated.component';
import { CustomerFilterComponent } from './shared/components/customer-filter/customer-filter.component';
import { DateFilterComponent } from './shared/components/date-filter/date-filter.component';
import { GenericCheckBoxComponent } from './shared/components/generic-check-box/generic-check-box.component';
import { GenericDateComponent } from './shared/components/generic-date/generic-date.component';
import { GenericInputFilterComponent } from './shared/components/generic-input-filter/generic-input-filter.component';
import { GenericRadioComponent } from './shared/components/generic-radio/generic-radio.component';
import { OnlineStoreFilterComponent } from './shared/components/online-store-filter/online-store-filter.component';
import { PaletteFilterComponent } from './shared/components/palette-filter/palette-filter.component';
import { PosFilterComponent } from './shared/components/pos-filter/pos-filter.component';
import { PriceFilterComponent } from './shared/components/price-filter/price-filter.component';
import { RoleFilterComponent } from './shared/components/role-filter/role-filter.component';
import { StyleGroupFilterComponent } from './shared/components/style-group-filter/style-group-filter.component';
import { TierFilterComponent } from './shared/components/tier-filter/tier-filter.component';
import { VariantSizeComponent } from './shared/components/variant-size/variant-size.component';
import { ProductsFilterComponent } from './shared/components/products-filter/products-filter.component';
import { UserFilterComponent } from './shared/components/user-filter/user-filter.component';
import { CustomDateTimePickerModule } from '../custom-date-time-picker/custom-date-time-picker.module';
import { SeasonReferenceFilterComponent } from './shared/components/season-reference-filter/season-reference-filter.component';
import { VoucherFilterComponent } from './shared/components/voucher-filter/voucher-filter.component';
import { CustomizationRequestsFilterComponent } from './shared/components/customization-requests-filter/customization-requests-filter.component';
import { ShowcasesFilterComponent } from './shared/components/showcases-filter/showcases-filter.component';
import { OrderFilterComponent } from './shared/components/order-filter/order-filter.component';
import { CustomerGroupCodeFilterComponent } from './shared/components/customer-group-code-filter/customer-group-code-filter.component';
import { CustomerSubgroupCodeFilterComponent } from './shared/components/customer-subgroup-code-filter/customer-subgroup-code-filter.component';
import { CustomerSignboardFilterComponent } from './shared/components/customer-signboard-filter/customer-signboard-filter.component';
import { CustomerHoldingFilterComponent } from './shared/components/customer-holding-filter/customer-holding-filter.component';
import { CustomerGroupFilterComponent } from './shared/components/customer-group-filter/customer-group-filter.component';
import { SalesTaxGroupFilterComponent } from './shared/components/sales-tax-group-filter/sales-tax-group-filter.component';

//TODO: analizzare l'eliminazione del/dei service dai providers
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbModule,
    SharedCommonModule,
    SidebarModule,
    PaginationModule,
    ScrollingModule,
    LoaderModule,
    DirectivesModule,
    NgxMaskDirective,
    CustomDateTimePickerModule,
    TranslateModule.forChild()
  ],
  declarations: [
    SearchBarComponent,
    RadioPaginatedComponent,
    GenericRadioComponent,
    AgencyFilterComponent,
    TierFilterComponent,
    OnlineStoreFilterComponent,
    CityFilterComponent,
    CustomerFilterComponent,
    OrderFilterComponent,
    PosFilterComponent,
    DateFilterComponent,
    NumberFilterComponent,
    PriceFilterComponent,
    AmountFilterComponent,
    RoleFilterComponent,
    GenericDateComponent,
    CheckRangePipe,
    CheckBoxPaginedComponent,
    GenericCheckBoxComponent,
    AssortmentFilterComponent,
    VariantSizeComponent,
    PaletteFilterComponent,
    BasicCollectionFilterComponent,
    InputFilterComponent,
    GenericInputFilterComponent,
    StyleGroupFilterComponent,
    ChannelFilterComponent,
    ProductsFilterComponent,
    UserFilterComponent,
    SeasonReferenceFilterComponent,
    VoucherFilterComponent,
    CustomizationRequestsFilterComponent,
    ShowcasesFilterComponent,
    CustomerGroupCodeFilterComponent,
    CustomerSubgroupCodeFilterComponent,
    CustomerSignboardFilterComponent,
    CustomerHoldingFilterComponent,
    CustomerGroupFilterComponent,
    SalesTaxGroupFilterComponent
  ],
  exports: [
    SearchBarComponent,
  ],
  providers: [
    SearchService,
    AgencyService,
    provideNgxMask()
  ]
})
export class SearchBarModule { }
